module.exports = __webpack_public_path__ + "static/media/Marshall Islands.4bf1fd87.png";